import React, { useState } from 'react';
import Table from '~/src/components/Table';
import { OteGameOteTeam } from '~/src/models/OteGameOteTeam';
import { OteTeam } from '~/src/models/OteTeam';
import { imgOteLogoWhiteSvg } from '../../images';
import { OteGame } from '../../models/OteGame';
import { getThemeTeam, OteTheme } from '../../models/OteTheme';
import './Periods.scss';

const TeamLogo = ({ ote_game, ote_team }: { ote_game: OteGame; ote_team: OteTeam }) => {
	const [themeTeam, setThemeTeam] = useState<OteTheme>(getThemeTeam(ote_team?.id, ote_game.theme_name));
	const [logoPath, setLogoPath] = useState<string>(
		themeTeam
			? `https://images.overtime.tv/${themeTeam.logo_path}`
			: ote_team?.small_logo_path
				? `https://images.overtime.tv/${ote_team?.small_logo_path}?width=80&format=webp`
				: ote_team?.logo_path
					? `https://images.overtime.tv/${ote_team?.logo_path}?width=80&format=webp`
					: `${imgOteLogoWhiteSvg}`,
	);

	return (
		<a
			href={ote_team ? `/teams/${ote_team?.slug}` : undefined}
			className="TeamLogo"
			style={{
				backgroundImage: `url(${logoPath})`,
			}}
		>
			{!ote_team?.small_logo_path && !ote_team?.logo_path ? ote_team?.team_code?.[0] : null}
		</a>
	);
};

const Row = ({ ote_game, ote_game_ote_team }: { ote_game: OteGame; ote_game_ote_team: OteGameOteTeam }) => (
	<tr>
		<th>
			<TeamLogo ote_game={ote_game} ote_team={ote_game_ote_team?.ote_team} />
			<a
				className="desktop-only"
				href={ote_game_ote_team?.ote_team ? `/teams/${ote_game_ote_team?.ote_team?.slug}` : undefined}
			>
				{ote_game_ote_team?.ote_team?.name ?? '-'}
			</a>
			<a
				className="mobile-only"
				href={ote_game_ote_team?.ote_team ? `/teams/${ote_game_ote_team?.ote_team?.slug}` : undefined}
			>
				{ote_game_ote_team?.ote_team?.team_code ?? '-'}
			</a>
		</th>
		{[1, 2, 3, 4].map((period) => (
			<td key={period}>
				{ote_game_ote_team?.ote_game_ote_team_periods?.find((p) => p.period_id === period)?.points ?? 0}
			</td>
		))}
		{[11, 12, 13, 14, 15]
			.map((period) =>
				ote_game_ote_team?.ote_game_ote_team_periods?.find((p) => p.period_id === period) ? (
					<td key={period}>
						{ote_game_ote_team?.ote_game_ote_team_periods?.find((p) => p.period_id === period)?.points ?? 0}
					</td>
				) : null,
			)
			.filter(Boolean)}

		<td className="Total">{ote_game_ote_team?.points ?? 0}</td>
	</tr>
);

const Periods = ({
	game,
	homeTeam,
	awayTeam,
}: {
	game: OteGame;
	homeTeam: OteGameOteTeam;
	awayTeam: OteGameOteTeam;
}) => {
	return (
		<div className="GamePeriods">
			<Table
				headers={[
					...['Q1', 'Q2', 'Q3', 'Q4'].map((p) => ({ label: p, mobileLabel: p.replace('Q', '') })),
					...[11, 12, 13, 14, 15]
						.map((ot) =>
							homeTeam?.ote_game_ote_team_periods?.find((p) => p.period_id === ot)
								? { label: `OT${ot > 11 ? ot - 10 : ''}` }
								: null,
						)
						.filter(Boolean),
					{ label: 'Total', mobileLabel: 'T' },
				]}
				currentHeader={''}
				rows={[
					<Row key="away" ote_game={game} ote_game_ote_team={awayTeam} />,
					<Row key="home" ote_game={game} ote_game_ote_team={homeTeam} />,
				]}
			/>
		</div>
	);
};
export default Periods;
